import { render, staticRenderFns } from "./title-controls.vue?vue&type=template&id=71537f63&"
import script from "./title-controls.vue?vue&type=script&lang=js&"
export * from "./title-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports